import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import pic08 from '../assets/images/pic08.jpg'
// import pic09 from '../assets/images/pic09.jpg'
import pic10 from '../assets/images/pic10.jpg'
import couch3 from '../assets/images/couch3.jpg'
import bike3 from '../assets/images/bike3.jpg'

const About = props => (
  <div>
    <Helmet>
      <title>Jody Smith - Homepage</title>
      <meta name="description" content="About Me Page" />
    </Helmet>

    <div id="main">
      <section id="banner" className="style2">
        <div className="inner">
          <header className="major">
            <h1>About Me</h1>
          </header>
          <div className="content">
            <p>
              I like to code, run spartan races and solve interesting problems.
            </p>
          </div>
        </div>
      </section>
      <section id="one">
        <div className="inner">
          <header className="major">
            <h2>My Work</h2>
          </header>
          <p>
            I am a life long learner and enjoy problem solving either for work
            or just for fun. My career started in the IT department doing
            Network Adminstration and I moved through Technical Sales and
            eventually ended up in Product Management. When the chance to learn
            how to code was available, I jumped at the chance to learn the one
            thing I felt I had been missing for so long.
          </p>
        </div>
      </section>
      <section id="two" className="spotlights">
        <section>
          <img src={pic08} alt="Spartan Racing" />

          <div className="content">
            <div className="inner">
              <header className="major">
                <h3>Spartan and OCR races</h3>
              </header>
              <p>
                I recently started running in Spartan races, because, why not?
                Miles and miles of hilly terrain with obstacles that feel like
                they were designed to break you. It's been a fun way to get back
                in shape and set a fitness goal. By the end of 2018 I completeed
                my first Spartan Trifecta (a Sprint, Super and Beast race of 7,
                14 and 21km length). Aroo!
              </p>
            </div>
          </div>
        </section>
        <section>
          <img src={couch3} alt="" />

          <div className="content">
            <div className="inner">
              <header className="major">
                <h3>I once built a couch from scratch</h3>
              </header>
              <p>
                I like to solve problems, so when I moved into my new house and
                the basement stairs weren't big enough for a larger couch, I
                built one. From learning wood work to build the frame,
                upholstery to afix the webbing, all the way to learning to sew
                for the cushions as well. It took a while, but the result was
                great :)
              </p>
            </div>
          </div>
        </section>
        <section>
          <img src={bike3} alt="" />

          <div className="content">
            <div className="inner">
              <header className="major">
                <h3>I Rebuilt a Motorcycle</h3>
              </header>
              <p>
                I used to own a GSXR 600 race bike, I had way too much fun on
                it. One day while riding on the "twisties", my inherant love of
                going fast was cut short by my lack of skill. I was unlucky
                enough to hit a little gravel on a sharp turn, and lucky enough
                to walk away from an insurance write off of my bike, with a
                sprained thumb. You win some you lose some. What do you do with
                a wrecked bike? You rebuild it. Thankfully the engine and frame
                were good, so I didn't have to get my hands too dirty. I got two
                more seasons out of it before I decided to quit while I was
                ahead. Now I get around on four wheels.
              </p>
            </div>
          </div>
        </section>
        <section>
          <img src={pic10} alt="" />

          <div className="content">
            <div className="inner">
              <header className="major">
                <h3>I Used to be a Bartender</h3>
              </header>
              <p>
                In a previous life I used to bartend downtown in Montreal, it
                turns out that not only is it a lot of fun, but talking to all
                kinds of people about all kinds of subjects helped a lot in
                learning how to best understand peoples problems when it came to
                product management. I also do a fair amount of public speaking
                on Digital Signage and Programmatic, and being able to talk to
                complete strangers like we're old friends just makes things
                easier.
              </p>
            </div>
          </div>
        </section>
      </section>
    </div>
  </div>
)

export default About



// WEBPACK FOOTER //
// ./src/pages/about.js